<template>
  <div>
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div class="mainContainer">
      <img style="" src="/img/corporate/tech-main.png" alt="" />
      <h1>{{ $t('technologyService.heroSection.title') }}</h1>
      <p>{{ $t('technologyService.heroSection.description') }}</p>
      <div class="tombol">
        <button class="konsultasi" @click="scrollToSection('collab')">
          {{ $t('technologyService.heroSection.buttons.collaborateNow') }}
        </button>
        <button class="hubungi" @click="sendToWa">{{ $t('technologyService.heroSection.buttons.contactUs') }}</button>
      </div>
    </div>
    <div class="banner-content">
      <h2 class="text-center font-poppins">
        {{ $t('technologyService.trustedBy') }}
      </h2>
      <div class="d-flex overflow-x-hidden overflow-y-hidden" style="height: 100%">
        <v-col cols="6" v-for="(data, idx) in partners" :key="idx" class="
            d-flex
            justify-content-center
            align-content-center
            scroll-container
          ">
          <v-img :src="data.img_url_mobile" contain />
        </v-col>
      </div>
    </div>
    <div style="background-color: white">
      <div style="padding: 20px" class="container text-center">
        <h2>{{ $t('technologyService.serviceHeader.title') }}</h2>
        <p>{{ $t('technologyService.serviceHeader.description') }}</p>
        <div>
          <div class="card-1 mt-8" v-for="(item, idx) in $t('technologyService.descs1')" :key="idx">
            <img :src="item.img" class="img-2" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>

      <div style="padding: 0px 20px" class="why-hicol">
        <h3 class="mt-10 text-center mb-3">{{ $t('technologyService.whyChooseUs.title') }}</h3>
        <p style="text-align: center; font-size: 12px" v-html="$t('technologyService.whyChooseUs.description')"></p>

        <div class="why-item mb-5" v-for="(item, idx) in $t('technologyService.usps')" :key="idx">
          <div :style="idx < $t('technologyService.usps').length - 1
              ? 'border-bottom: 1px solid #acafbf; padding-bottom: 30px;'
              : 'padding-bottom: 30px;'
            ">
            <img :src="item.icon" alt="" />
            <h4>
              {{ item.title }}
            </h4>
            <p class="mt-2 text-justify" style="font-size: 12px">
              {{ item.desc }}
            </p>
          </div>
        </div>
        <div class="card mb-5" style="
            object-fit: cover;
            height: 350px;
            display: block;
            overflow: hidden;
            padding: 0;
            border-radius: 30px;
          ">
          <img src="/img/corporate/tech/main-2.png" style="width: 100%" alt="" />
        </div>
      </div>
      <div style="padding: 0px 20px" class="bg-linear">
        <div class="collaboratif">
          <h2 class="mb-4 text-center">{{ $t('technologyService.a2') }}</h2>
          <v-col style="margin: 20px 0px" class="d-flex justify-end align-center">
            <CollaborationCircle :width="24" :height="24" style="z-index: 1" />
            <div style="
                height: 1px;
                width: 100%;
                border: 1px dashed grey;
                left: 50%;
                z-index: 0;
              " />
          </v-col>
          <div class="desc">
            <div class="card-content" v-for="(data, index) in $t('technologyService.steps')" :key="index">
              <div class="card-img">
                <img :src="data.image_url" width="300" alt="" style="margin-top: -20px" />
              </div>
              <div class="desc">
                <h3>{{ data.title }}</h3>
                <p>{{ data.description }}</p>
              </div>
            </div>
          </div>
          <div class="indicator-container">
            <div style="width: 10px; height: 10px"></div>
            <div class="indicator">
              <svg :style="{ transform: `translateX(${indicator * 15}px)` }" width="25" height="10" viewBox="0 0 25 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="25" height="10" rx="5" fill="#162CA2" />
              </svg>
              <svg :style="{ transform: `translateX(${-indicator2 * 30}px` }" width="10" height="10" viewBox="0 0 10 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill="#7B7E8C" />
              </svg>
              <svg :style="{ transform: `translateX(${-indicator3 * 30}px` }" width="10" height="10" viewBox="0 0 10 10"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="5" r="5" fill="#7B7E8C" />
              </svg>
            </div>

            <div class="btn-arrow">
              <div class="btn-card">
                <img src="/img/other/corporate-arrow-left.png" alt="" @click="scrollLeftStep" />
              </div>
              <div class="btn-card">
                <img src="/img/other/corporate-arrow-right.png" alt="" @click="scrollRightStep" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="project">
        <h1>{{ $t('technologyService.a1') }}</h1>
        <div>
          <div v-for="(item, idx) in portfolios" :key="idx">
            <div v-if="idx === portfoliosModel">
              <div class="img-card">
                <img :src="item.image_url" :alt="item.title" />
              </div>
              <div class="card-port">
                <div class="content-port">
                  <h2>{{ item.title }}</h2>
                  <p class="short">{{ item.program }}</p>
                  <p class="desc">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <v-row style="margin: 0px 10px; padding: 0px 10px" class="d-flex align-center">
            <v-col cols="8">
              <div class="slider">
                <div class="indicator" :style="{
                  width: `${sliderIndicatorPortfolios}%`,
                  transform: `translateX(${indicatorValuePortfolios}%)`,
                  transition: `transform 0.5s`,
                }"></div>
              </div>
            </v-col>
            <v-col cols="4" class="d-flex" style="justify-content: flex-end; gap: 11px">
              <v-btn v-for="index in 2" fab :key="index" @click="index === 1 ? PortfoliosPrev() : PortfoliosNext()"
                class="btn-mobile-slider-corp" elevation="0">
                <ArrowIcon style="color: white" :direct="index === 1 ? 'right' : 'left'" />
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div style="padding: 0px 20px" class="form-konsultasi">
        <div class="header text-center">
          <h2 style="font-weight: 700; line-height: 22px; width: 100%">
            {{ $t('technologyService.formSection.title') }}
          </h2>
        </div>
        <div class="sub-heading mt-1 text-center">
          <p style="
              font-weight: 400;
              font-size: 12px;
              line-height: 24px;
              text-align: center;
            ">
            {{ $t('technologyService.formSection.description') }}
          </p>
          <v-form class="text-start" style="margin-top: 60px" id="collab">
            <div>
              <label class="form-label" for="company">{{ $t('technologyService.formSection.labels.companyName') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
                :placeholder="$t('technologyService.formSection.placeholders.companyName')"
                :full-width="true"></v-text-field>
            </div>
            <div>
              <label class="form-label" for="website">{{ $t('technologyService.formSection.labels.website') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" v-model="form.web_url" name="website" outlined
                :placeholder="$t('technologyService.formSection.placeholders.website')"></v-text-field>
            </div>

            <div>
              <label class="form-label" for="pic-name">{{ $t('technologyService.formSection.labels.picName') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="pic-name" v-model="form.full_name" outlined
                :placeholder="$t('technologyService.formSection.placeholders.picName')"></v-text-field>
            </div>
            <div>
              <label class="form-label" for="email">{{ $t('technologyService.formSection.labels.email') }}<span
                  style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="email" outlined v-model="form.email"
                :placeholder="$t('technologyService.formSection.placeholders.email')" max-width></v-text-field>
            </div>

            <div>
              <label class="form-label" for="occupation">{{ $t('technologyService.formSection.labels.occupation')
                }}</label>
              <v-text-field class="form-input text-form" name="occupation" outlined v-model="form.job_pic"
                :placeholder="$t('technologyService.formSection.placeholders.occupation')">
              </v-text-field>
            </div>
            <div>
              <label class="form-label" for="phone-number">{{ $t('technologyService.formSection.labels.phoneNumber')
                }}<span style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-text-field class="form-input text-form" name="phone-number" outlined
                :placeholder="$t('technologyService.formSection.placeholders.phoneNumber')" v-model="form.phone_number"
                type="number" hide-spin-buttons>
                <template v-slot:prepend-inner>
                  <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                    style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                  <span style="color: #575966" class="mx-3">+62</span>
                </template>
              </v-text-field>
            </div>
            <v-col cols="12">
              <label class="form-label" for="collaboration">{{
                $t('technologyService.formSection.labels.collaborationType')
                }}</label>
              <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
                :placeholder="$t('technologyService.formSection.placeholders.collaborationType')" disabled />
            </v-col>
            <v-row class="d-flex justify-center align-center mt-3">
              <v-checkbox style="width: 100%; margin: 0px 20px" class="form-input custom-checkbox" v-model="is_confirm">
                <template v-slot:label>
                  <h5 class="label-checkbox" v-html="$t('technologyService.formSection.labels.confirmCheckbox')"></h5>
                </template>
              </v-checkbox>
            </v-row>
            <v-row style="width: 100%" class="d-flex justify-center align-center mt-6">
              <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">{{
                $t('technologyService.formSection.buttons.submit') }}
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </div>
    </div>
    <div class="faqbg">
      <div class="faq">
        <h1>Frequently Asked Question</h1>
        <div class="container">
          <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
            :description="item.description" :active="item.active" @toggle="toggleAccordion(index, item.title)" />
          <div class="btn-stoke-blue cursor-pointer mt-5" @click="goToFaq">
            <span class="font-poppins">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/others/Popup.vue";
import CollaborationCircle from "@/components/ilustration/CollaborationCircle.vue";
import ArrowIcon from "@/assets/icons/Arrow.vue";
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  components: {
    Popup,
    CollaborationCircle,
    AccordeonFaq,
    ArrowIcon,
  },
  data() {
    return {
      portfolios: [],
      questions: [],
      partners: [],
      inovation: [
        {
          img: "/img/corporate/tech/w1.png",
          name: "Finansial & Perbankan",
        },
        {
          img: "/img/corporate/tech/w2.png",
          name: "Kesehatan",
        },
        {
          img: "/img/corporate/tech/w3.png",
          name: "Pendidikan",
        },
        {
          img: "/img/corporate/tech/w4.png",
          name: "Manufaktur",
        },
        {
          img: "/img/corporate/tech/w5.png",
          name: "Energi & Sumber Daya",
        },
        {
          img: "/img/corporate/tech/w6.png",
          name: "Pemerintahan",
        },
        {
          img: "/img/corporate/tech/w7.png",
          name: "Media",
        },
        {
          img: "/img/corporate/tech/w8.png",
          name: "Pariwisata",
        },
      ],
      steps: [
        {
          image_url: "/img/corporate/tech/bn1.png",
          title: "Analisis Kebutuhan",
          description:
            "HiColleagues memulai dengan melakukan sesi konsult  untuk memahami kebutuhan dan tujuan bisnis Anda. Tim kami akan menganalisis tantangan yang Anda hadapi dan mengidentifikasi area yang memerlukan dukungan teknologi.",
        },
        {
          image_url: "/img/corporate/tech/bn2.png",
          title: "Rekomendasi Strategi & Solusi",
          description:
            "Kami menyusun rekomendasi solusi teknologi yang paling sesuai dengan kebutuhan Anda. Rekomendasi ini mencakup pilihan layanan seperti IT Consulting, IT Oursourcing, IT Headhunting, hingga IT Support.",
        },
        {
          image_url: "/img/corporate/tech/bn3.png",
          title: "Strategi, Timeline, & Achievement",
          description:
            "Setelah rekomendasi disetujui, tim kami bekerja sama dengan Anda untuk merancang solusi yang detail dan disesuaikan. Ini termasuk penyusunan rencana implementasi dan perancangan teknologi yang optimal.",
        },
        {
          image_url: "/img/corporate/tech/bn4.png",
          title: "IT Headhunting",
          description:
            "Layanan pencarian dan perekrutan talenta IT secara khusus untuk membantu perusahaan menemukan kandidat berkualitas yang sesuai dengan kebutuhan teknis, pengalaman, dan budaya organisasi. Dengan memahami kebutuhan industri teknologi serta menggunakan pendekatan targeted search, kami dapat menjangkau kandidat potensial, termasuk talenta profesional yang tidak aktif mencari pekerjaan (passive candidates)",
        },
        {
          image_url: "/img/corporate/tech/bn5.png",
          title: "Evaluasi & Optimalisasi",
          description:
            "Pasca proyek, HiColleagues melakukan evaluasi untuk menilai kinerja solusi yang telah diimplementasikan. memastikan operasional teknologi berjalan tanpa hambatan. Hal ini seperti maintenance rutin, troubleshooting, dan pembaruan sistem.",
        },
      ],
      indicator: 0,
      indicator2: 0,
      indicator3: 0,
      portfoliosModel: 0,
      indicatorValuePortfolios: 0,
      sliderIndicatorPortfolios: 0,
      sliderIndicator: 0,
      indicatorValue: 0,
      alertErrMessage: "",
      isAlertErr: false,
      is_confirm: false,
      isError: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "SERVICES",
        web_url: "",
        job_pic: "",
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getPortofolio();
      this.getFaq();
    }
  },
  methods: {
    PortfoliosNext() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Portfolio Next - IT Resourcing Mobile',
        value: 1,
      });
      if (this.portfoliosModel < this.portfolios.length - 1) {
        this.portfoliosModel += 1;
        this.indicatorValuePortfolios += this.sliderIndicatorPortfolios + 50;
      }
      if (this.indicatorValuePortfolios === 100) {
        return;
      }
    },
    PortfoliosPrev() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Portfolio Previous - IT Resourcing Mobile',
        value: 1,
      });
      if (this.portfoliosModel > 0) {
        this.portfoliosModel -= 1;
      }
      if (this.indicatorValuePortfolios === 0) {
        return;
      }
      this.indicatorValuePortfolios -= this.sliderIndicatorPortfolios + 50;
    },
    scrollRightStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Right - Collaboration Steps - IT Resourcing Mobile',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft += cardWidth * 1.07;
      if (this.indicator < 2) {
        this.indicator++;
        if (this.indicator2 < 1) {
          this.indicator2++;
        }
      }
      if (this.indicator === 2 && this.indicator3 < 1) {
        this.indicator3++;
      }
    },
    scrollLeftStep() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Scroll Left - Collaboration Steps - IT Resourcing Mobile',
        value: 1,
      });
      const container = this.$el.querySelector(".desc");
      const cardWidth = this.$el.querySelector(".card-content").offsetWidth;
      container.scrollLeft -= cardWidth * 1.07;
      if (this.indicator === 1) {
        this.indicator2--;
      }
      if (this.indicator > 0) {
        this.indicator--;
      }
      if (this.indicator3 < 2 && this.indicator > 0) {
        this.indicator3--;
      }
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=SERVICES");
        this.partners = resp.data.data.logos;
      } catch (err) {
        console.log(err);
      }
    },
    async getPortofolio() {
      try {
        const resp = await this.$http.get(`/v1/project-portfolio?category=SERVICES&is_main=true`);
        this.portfolios = resp.data.data.project_portfolios;
        this.sliderIndicatorPortfolios =
          100 / resp.data.data.project_portfolios.length + 4;
      } catch (err) {
        console.log(err);
      }
    },
    toggleAccordion(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Toggle FAQ - ${title} - IT Resourcing Mobile`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=SERVICES&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - IT Resourcing Mobile',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Collaborate Now - Scroll to Form - IT Resourcing Mobile',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit IT Resourcing Form - Mobile',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (
        !this.form.corporate_name ||
        !this.form.full_name ||
        !this.form.job_pic ||
        !this.form.email ||
        !this.form.phone_number ||
        !this.form.category ||
        !this.form.web_url
      ) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'IT Resourcing Form Submission Error - Mobile',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post("/v1/corporate-registration", this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'IT Resourcing Form Submission Success - Mobile',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'IT Resourcing Form Submission Error - Mobile',
          value: 0,
        });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - IT Resourcing Mobile',
        value: 1,
      });
      this.$router.push('/faq');
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
    },
  },
  mounted() {
    this.getFaq();
    this.getPortofolio();
    this.getClientLogo();
    this.$gtag.pageview(this.$route);
  },
  beforeMount() {
    this.sliderIndicator = (1 / this.portfolios.length) * 100;
  },
};
</script>

<style src="./technologyService.css" scoped></style>